'use client'

import { useEffect, useState } from 'react'
import { ArrowUp } from 'lucide-react'
import { useMessages } from '@/lib/i18n/client'
import messages from './ScrollToTopButton.i18n'

const SHOW_AFTER_PX = 400

// Botón flotante que aparece al hacer scroll hacia abajo y permite volver
// arriba con un clic — complementa el reset automático de scroll al navegar
// entre pantallas (ver ScrollToTop.tsx), para el caso de quedarse en la
// MISMA pantalla y haber bajado mucho (ej. el detalle de un evento largo).
export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false)
  const t = useMessages(messages)

  useEffect(() => {
    function onScroll() {
      setVisible(window.scrollY > SHOW_AFTER_PX)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t.backToTop}
      className="fixed bottom-6 right-6 z-[1000] flex h-11 w-11 items-center justify-center rounded-full bg-foreground text-background shadow-lift transition hover:opacity-90"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  )
}
